import React, { useEffect, useState } from "react";
import { Table, Space, Row, Col, Input, Select, Button, Pagination, Tag, Badge } from "antd";
import { EyeOutlined, SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { dropdownService, vehicleService } from "../../../services";
import { GoDotFill, GoKey } from "react-icons/go";
import { LuFolderSearch2, LuTruck } from "react-icons/lu";
import { FaRegFileAlt } from "react-icons/fa";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { withDefaultRender } from "../../../utils/tableDefaultRender";
import { GiReturnArrow } from "react-icons/gi";
import { changeDocumentTitle } from "../../../utils/title";
import CardSkeleton from "../../../utils/skeleton";
import { CiFilter } from "react-icons/ci";
import AdvancedFilter from "../../../components/AdvancedFilter";
import { useDebounce } from "../../../hooks/useDebounce";

const options = [
    {
        value: "10",
        label: "10",
    },
    {
        value: "9",
        label: "9",
    },
];

function CustomerVechical() {

    const [loading, setLoading] = useState(false)
    const [search, setSearch] = useState(null)
    const [vehicles, setVehicles] = useState([])
    const [status, setStatus] = useState([])
    const [pagination, setPagination] = useState({
        current: 1,
        total: 0,
        pageSize: 10,
    });
    const debouncedSearch = useDebounce(search, 500);
    const [showFilters, setShowFilters] = useState(false);
    const [filterValues, setFilterValues] = useState({});
    const [destination, setDestination] = useState([])
    const [allVehicle, setAllVehicle] = useState([])

    const startYear = 1990;
    const endYear = new Date().getFullYear();

    const yearOptions = [];
    for (let y = endYear; y >= startYear; y--) {
        yearOptions.push({ label: String(y), value: String(y) });
    }

    const uniqueVehicleOptions = [
        { label: "All", value: null },
        ...Array.from(
            new Map(
                allVehicle.map(v => [v.vehicle.trim(), v.vehicle.trim()])
            ).values()
        ).map(vehicle => ({
            label: vehicle,
            value: vehicle,
        })),
    ];

    const columns = withDefaultRender([
        {
            title: "S.No",
            dataIndex: "Id",
            key: "_id",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Car Status",
            dataIndex: "car_status",
            key: "car_status",
            render: (text) => (
                <>
                    {text === "LOADED" ? <Tag color="green">{text}</Tag> : text === "AT YARD" ? <Tag color="gold">{text}</Tag> : text === "IN LOAD PLAN" ? <Tag color="blue">{text}</Tag> : text === "RETURNED" ? <Tag color="red">{text}</Tag> : null}
                </>
            )
        },
        // {
        //     title: "User Id",
        //     dataIndex: "user_id",
        //     key: "user_id",
        // },
        {
            title: "Title Available",
            dataIndex: "title",
            key: "title",
            // render: (text) => text || "-"
        },
        {
            title: "Destination",
            dataIndex: "destination",
            key: "destination",
        },
        {
            title: "Vehicle",
            dataIndex: "vehicle",
            key: "vehicle",
        },
        {
            title: "Model",
            dataIndex: "product",
            key: "product",
        },
        {
            title: "Year",
            dataIndex: "year",
            key: "year",
        },
        {
            title: "Chassis No",
            dataIndex: "chasis_no",
            key: "chasis_no",
        },
        {
            title: "Invoice No",
            dataIndex: "invoice_no",
            key: "invoice_no",
            render: (text) =>
                text === null ? (
                    <span className="text-[#BFBFBF]">
                        Not Issued
                    </span>
                ) : (
                    <a
                        href={`/invoice/view/${text}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline text-primary hover:text-primary hover:underline"
                    >
                        {text}
                    </a>
                ),
        },
        {
            title: "Action",
            fixed: "right",
            key: "Action",
            render: (text, record, id) => (
                <Space size="small">
                    <Link to={`/vehicle/${record.id}`} className="hover:text-primary">
                        {/* <Button type="primary" size="small"> */}
                        <EyeOutlined style={{ fontSize: "15px" }} />
                        {/* </Button> */}
                    </Link>
                </Space>
            ),
        },
    ])

    const cardData = [
        { title: 'Total Vehicles', count: pagination.total, imgSrc: <LuTruck style={{ padding: 6, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "44px", borderRadius: "8px" }} />, path: '/customers-portal/atvechile' },
        { title: 'In Load Plans', count: status?.IN_LOAD_PLAN, imgSrc: <FaRegFileAlt style={{ padding: 6, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "44px", borderRadius: "8px" }} />, path: '/customers-portal/atvechile' },
        { title: 'Loaded', count: status?.LOADED, imgSrc: <HiOutlineCheckCircle style={{ padding: 4, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "44px", borderRadius: "8px" }} />, path: '/customers-portal/atvehicle-without-title' },
        { title: 'At Yard', count: status?.AT_YARD, imgSrc: <LuFolderSearch2 style={{ padding: 6, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "44px", borderRadius: "8px" }} />, path: '/customers-portal/atvehicle-without-key' },
        { title: 'Returned', count: 0, imgSrc: <GiReturnArrow style={{ padding: 6, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "44px", borderRadius: "8px" }} />, path: '/customers-portal/atvehicle-without-key' },
    ];

    const allDestination = async () => {
        const response = await dropdownService.fetchDestination()
        if (response?.success) {
            setDestination(response.data)
        }
    }

    const fetchAllVehicle = async () => {
        const response = await dropdownService.fetchVehicles()
        if (response?.success) {
            setAllVehicle(response.data)
        }
    }

    const vehicleFilters = [
        {
            name: "car_status",
            label: "Car Status",
            options: [
                { label: "Loaded", value: "LOADED" },
                { label: "At Yard", value: "AT YARD" },
                { label: "In Load Plan", value: "IN LOAD PLAN" },
                { label: "Returned", value: "RETURNED" },
            ],
        },
        {
            name: "year",
            label: "Year",
            options: yearOptions
        },
        {
            name: "vehicle",
            label: "Vehicle",
            options: uniqueVehicleOptions
        },
        {
            name: "destination",
            label: "Destination",
            options: destination.map(dest => ({ label: dest.name, value: dest.name }))
        },
    ]

    const vehicleFetch = async (page = 1, pageSize = pagination.current) => {
        setLoading(true)
        const { success, data } = await vehicleService.getVehicles(page, debouncedSearch, filterValues)
        setLoading(false)
        if (success) {
            setVehicles(data.vehicles.data)
            setStatus(data.status_counts)
            setPagination((prev) => ({
                ...prev,
                total: data.vehicles.total,
                current: page,
                pageSize,
            }));
        }
    }

    const handleFilterChange = (name, value) => {
        setFilterValues((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const activeFilterCount = Object.values(filterValues).filter(Boolean).length;

    const handleResetFilters = () => {
        setFilterValues({});
        vehicleFetch(1, pagination.pageSize);
    };

    useEffect(() => {
        allDestination();
        fetchAllVehicle();
    }, []);
    
    useEffect(() => {
        changeDocumentTitle(" Vehicles");
        vehicleFetch(pagination.current, pagination.pageSize);
    }, [filterValues, search])

    return (
        <>
            <div gutter={[24, 24]} className="flex gap-5">
                {cardData.map((data, index) => (
                    <div className='p-3 bg-white w-full border-[#D9D9D9] border-2 rounded-xl'>
                        {loading ?
                            <CardSkeleton />
                            :
                            <div className="flex gap-5 ">
                                {data.imgSrc}
                                <div className=''>
                                    <h1 className='text-[11px]'>{data.title}</h1>
                                    <h2 className="text-3xl">{data.count}</h2>
                                </div>
                            </div>
                        }
                    </div>
                ))}
            </div>
            <h1 className='mt-5 mb-6 text-sm font-normal uppercase flex items-center gap-2'><span><GoDotFill style={{ color: "#B83D3D" }} /></span>ALL VEHICLES LIST</h1>

            <div className="customer1-table-wrapper">
                <div className="flex items-center gap-2">
                    <Input
                        placeholder="Search by Vehicle & Chassis no"
                        prefix={<SearchOutlined />}
                        style={{
                            width: "100%",
                            height: "45px",
                            borderRadius: "5px",
                            fontSize: 14,
                            margin: 10
                        }}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    {/* <Badge count={activeFilterCount}>
                        <Button icon={<CiFilter style={{ fontSize: 22 }} />} className="h-11" type={showFilters ? 'primary' : 'default'} onClick={() => setShowFilters(prev => !prev)}
                        >Advanced Filter </Button>
                    </Badge> */}
                </div>
                <div className="p-3">
                    <AdvancedFilter
                        visible={true}
                        customer={true}
                        filters={vehicleFilters}
                        values={filterValues}
                        onChange={handleFilterChange}
                        onReset={handleResetFilters}
                    />
                </div>

                <Table
                    columns={columns}
                    dataSource={vehicles}
                    loading={loading}
                    pagination={false}
                    scroll={{ x: "max-content" }}
                    style={{ marginTop: "1px" }}
                    footer={() => (
                        <div className="flex justify-between items-center text-xs ">
                            <div className=" text-gray-600">
                                Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
                                {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
                                {pagination.total} entries
                            </div>
                            <Pagination
                                current={pagination.current}
                                total={pagination.total}
                                pageSize={pagination.pageSize}
                                showSizeChanger={false}
                                onChange={(page) => vehicleFetch(page, pagination.pageSize, search)}
                                itemRender={(current, type, originalElement) => {
                                    if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                                    if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                                    return originalElement;
                                }}
                            />
                        </div>
                    )}
                />
            </div>

        </>

    );
}

export default CustomerVechical;
